import { render, staticRenderFns } from "./EditLeadPaymentsDialog.vue?vue&type=template&id=35827942&scoped=true"
import script from "./EditLeadPaymentsDialog.vue?vue&type=script&lang=ts"
export * from "./EditLeadPaymentsDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditLeadPaymentsDialog.vue?vue&type=style&index=0&id=35827942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35827942",
  null
  
)

export default component.exports